import Typography from "@mui/material/Typography";
import { Box, Stack } from "@mui/material";
import type { FC, ReactNode } from "react";
import { PAGE_PADDING_X } from "../../../shared/Page";

const STATS_LIST_PADDING_X = 3;

export const StatsList: FC<{ label: string; labelIcon?: ReactNode; children: ReactNode }> = ({
  label,
  labelIcon,
  children,
}) => {
  return (
    <Stack>
      <Stack
        sx={{
          flexDirection: "row",
          alignItems: "end",
          pb: 2,
          px: STATS_LIST_PADDING_X,
          borderBottom: 1,
          justifyContent: "space-between",
          borderColor: "divider",
        }}
      >
        <Typography variant="h2" sx={{ fontWeight: 600 }}>
          {label}
        </Typography>

        {labelIcon}
      </Stack>
      <Stack sx={{ borderColor: "divider" }}>{children}</Stack>
    </Stack>
  );
};

export const StatsListItem: FC<{
  onClick: () => void;
  icon?: ReactNode;
  label: string;
  formattedPercentage: string;
  count: number;
}> = ({ onClick, icon, label, formattedPercentage, count }) => {
  return (
    <Box
      onClick={onClick}
      component="button"
      sx={{
        "border": "none",
        "bgcolor": "transparent",
        "display": "flex",
        "borderBottom": "1px solid",
        "borderColor": "divider",
        "alignItems": "center",
        "justifyContent": "space-between",
        "py": 1,
        "pl": STATS_LIST_PADDING_X,
        "pr": PAGE_PADDING_X,
        "cursor": "pointer",
        "&:hover": { bgcolor: theme => theme.palette.action.hover },
        "&:focus-visible": { bgcolor: theme => theme.palette.action.focus },
      }}
    >
      <Stack direction="row" sx={{ alignItems: "center", gap: 1.5 }}>
        {icon}
        <Typography sx={{ fontSize: theme => theme.typography.pxToRem(14), fontWeight: 600 }}>{label}</Typography>
      </Stack>
      <Stack direction="row" sx={{ alignItems: "center", gap: 2 }}>
        <Typography
          component="span"
          sx={{ fontSize: theme => theme.typography.pxToRem(14), color: theme => theme.palette.text.secondary }}
        >
          {formattedPercentage}
        </Typography>
        <Typography
          sx={{ minWidth: 40, textAlign: "right", fontWeight: 600, fontSize: theme => theme.typography.pxToRem(14) }}
        >
          {count}
        </Typography>
      </Stack>
    </Box>
  );
};

export const getFormatedPercentage = (count: number, total: number): string => {
  if (total === 0) return "0%";
  const percentage = (count / total) * 100;
  return percentage < 1 && percentage > 0 ? "<1%" : `${Math.round(percentage)}%`;
};
